import { fetchTelegramIdentityRequest } from '../fetch-telegram-identity-request';
import type { IConfirmTelegramOidcSwitchRequest } from './confirm-telegram-oidc-switch-request';
import type { IConfirmTelegramOidcSwitchResponse } from './confirm-telegram-oidc-switch-response';
import { confirmTelegramOidcSwitchResponseSchema } from './confirm-telegram-oidc-switch-response';

export async function confirmTelegramOidcSwitchApi(
  data?: IConfirmTelegramOidcSwitchRequest,
): Promise<IConfirmTelegramOidcSwitchResponse> {
  const response = await fetchTelegramIdentityRequest('/telegram/oidc/confirm-switch', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data ?? {}),
  });
  if (!response.ok) {
    throw new Error(`Telegram OIDC switch failed: ${response.status}`);
  }
  const json = await response.json();
  return confirmTelegramOidcSwitchResponseSchema.parse(json);
}
